import IMask from "imask";
import intlTelInput from "intl-tel-input";
import { ru } from "intl-tel-input/i18n";
import { ro } from "intl-tel-input/i18n";

import "intl-tel-input/build/css/intlTelInput.css";
import utilsUrl from "intl-tel-input/build/js/utils.js?url";

const initForm = ()=> {

    const currentLocale = document.documentElement.lang === 'ru' ? ru : ro;

    const initFormInputs = () => {

        /* ===================== PHONE INPUT ===================== */

        const inputPhoneElms = document.querySelectorAll('.input--phone-mask');

        inputPhoneElms.forEach((input) => {

            const initialCountry = input.dataset.country || 'md';

            const iti = intlTelInput(input, {
                i18n: currentLocale,
                separateDialCode: true,
                useFullscreenPopup: false,
                initialCountry,
                autoPlaceholder: "polite",
                placeholderNumberType: "MOBILE",
                loadUtils: () => import(/* @vite-ignore */ utilsUrl),
                // customPlaceholder: (ph) => ph.replace(/[0-9]/g, "X"),
            });

            input._phone = { iti, mask: null };

            const rebuildMask = () => {

                const ph = (input.placeholder || "").trim();
                if (!ph) return;

                const imaskPattern = ph.replace(/[0-9]/g, "0");

                if (input._phone.mask) {
                    input._phone.mask.destroy();
                }

                const newMask = IMask(input, {
                    mask: imaskPattern,
                    lazy: true,
                    overwrite: true,
                });

                input._phone.mask = newMask;

                const digits = input.value.replace(/\D/g, "");
                newMask.value = digits;
            };

            if (iti.promise) iti.promise.then(rebuildMask);
            else rebuildMask();

            input.addEventListener("countrychange", () => {
                if (input._phone.mask) input._phone.mask.value = "";
                else input.value = "";

                input.closest(".form__item")?.classList.remove("is--filled");

                rebuildMask();
            });
        });

        /* ===================== OTHER MASKS ===================== */

        const inputDateElms = document.querySelectorAll('.input--date-mask');
        inputDateElms.forEach((item) => {
            // const maskDate = IMask(item, { mask: Date });
            // maskDate.on('complete', () => { completed = true; });
            IMask(item, { mask: Date });
        });

        const inputYearElms = document.querySelectorAll('.input--year-mask');
        inputYearElms.forEach((item) => {
            // const maskYear = IMask(item, { mask: '0000' });
            // maskYear.on('complete', () => { completed = true; });
            IMask(item, { mask: '0000' });
        });

        const inputBirthDateElms = document.querySelectorAll('.input--birth-date-mask');
        inputBirthDateElms.forEach((item) => {
            IMask(item, {
                mask: Date,
                min: new Date(1900, 0, 1),
                max: new Date(),
            });
        });

        const formInputOnlyNumbersElms = document.querySelectorAll('.input--only-numbers');
        formInputOnlyNumbersElms.forEach((item) => {
            item.addEventListener('input', function() {
                item.value = item.value.replace(/[^0-9]/g, '')
            });
        });

        const formTogglePasswordElms = document.querySelectorAll('[data-toggle-password]');
        formTogglePasswordElms.forEach((button) => {
            button.addEventListener('click', function() {
                const input = button.closest('.form__item').querySelector('input');
                if (input.type === 'password') {
                    input.type = 'text';
                    button.classList.add('shown')
                } else {
                    input.type = 'password';
                    button.classList.remove('shown')
                }
            });
        });

        /* ===================== FORMS focus/fill/errors ===================== */

        const formElms = document.querySelectorAll('.form__block');

        formElms.forEach((formElm) => {
            const inputFields = formElm.querySelectorAll(
                'input[type="text"], input[type="password"], input[type="tel"], textarea'
            );
            const formLabelElms = formElm.querySelectorAll('.form__item_label');

            inputFields.forEach((input) => {
                input.addEventListener('input', () => {
                    if (input.closest('.form__item')) removeFieldError(input);
                });
            });

            formElm.querySelectorAll('input[type="checkbox"]').forEach((input) => {
                input.addEventListener('change', () => {
                    if (input.closest('.form__item')) removeFieldError(input);
                });
            });

            formElm.querySelectorAll('select').forEach((select) => {
                select.addEventListener('change', () => removeFieldError(select));
            });

            formLabelElms.forEach((label) => {
                label.addEventListener('click', () => {
                    const inputElm = label.previousElementSibling;
                    if (inputElm) inputElm.focus();
                });
            });

            inputFields.forEach((item) => {
                const onFocus = () => {
                    const itemParentElm = item.closest('.form__item');
                    if (!itemParentElm) return;

                    document.querySelectorAll('.form__item.is--focused')
                        .forEach((el) => el.classList.remove('is--focused'));

                    itemParentElm.classList.add('is--focused');
                };

                item.addEventListener('focus', onFocus);
                item.addEventListener('click', onFocus);
            });
        });
    };

    const scrollToFirstError = (formElm) => {
        const firstErrorItem = formElm.querySelector('.form__item.has--error');
        if (!firstErrorItem) return;

        const rect = firstErrorItem.getBoundingClientRect();
        const targetY = window.scrollY + rect.top - (window.innerHeight * 0.2);

        window.scrollTo({
            top: Math.max(targetY, 0),
            left: 0,
            behavior: 'smooth',
        });

        const focusTarget = firstErrorItem.querySelector('input, select, textarea, button');
        focusTarget?.focus?.({ preventScroll: true });
    };

    const toggleRequiredFieldsAlert = (formElm, visible = false) => {
        const alertElm = formElm?.querySelector('[data-required-fields-alert]');
        if (!alertElm) return;

        alertElm.classList.toggle('hidden', !visible);
    };

    const renderFormErrors = (error, formElm) => {
        formElm.querySelectorAll('.form__item_error').forEach(el => {
            el.textContent = '';
        });
        toggleRequiredFieldsAlert(formElm, false);

        if (error.response?.data?.errors) {
            const errors = error.response.data.errors;
            const formDataClass = formElm.dataset.form;

            for (const field in errors) {
                const errorField = `${formDataClass}-${field}-error`;
                showFieldError(errorField, errors[field], formElm);
            }

            toggleRequiredFieldsAlert(formElm, Object.keys(errors).length > 0);
            setTimeout(() => scrollToFirstError(formElm), 50);
        }
    };

    const showFieldError = (errorField, errorMessage, formElm) => {
        const errorElement = formElm.querySelector('#' + errorField);
        if (errorElement) {
            errorElement.textContent = errorMessage[0];
            errorElement.closest('.form__item')?.classList.add('has--error');
        }
    };

    const removeFieldError = (input) => {
        const item = input.closest?.('.form__item');
        if (!item) return;

        const errorElement = item.querySelector('.form__item_error');
        if (errorElement && String(input.value || '').trim() !== '') {
            errorElement.textContent = '';
            item.classList.remove('has--error');
        }

        const formElm = input.closest?.('.form__block');
        if (formElm && !formElm.querySelector('.form__item.has--error')) {
            toggleRequiredFieldsAlert(formElm, false);
        }
    };

    return {
        initFormInputs,
        renderFormErrors,
        removeFieldError,
        scrollToFirstError,
    }
}

export default initForm;
